'use client';

import { useEffect } from 'react';

import { logNextErrorBoundary } from './_components/errorBoundaryReporting';

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    logNextErrorBoundary(error, 'global');
  }, [error]);

  return (
    <html lang="en" data-panda-theme="hotpads">
      <body>
        <main style={{ margin: '0 auto', maxWidth: 720, padding: '64px 24px', fontFamily: 'sans-serif' }}>
          <h1>Something went wrong</h1>
          <p>We could not load HotPads. Try again in a moment.</p>
          {error.digest && <p>Reference: {error.digest}</p>}
          <button type="button" onClick={reset}>
            Try again
          </button>
        </main>
      </body>
    </html>
  );
}
